import { IpadIntegrationsModels } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<IpadIntegrationsModels>('/ipad/ipad-integrations');
export default api;
